<template lang="html">
  <div>
    <events-item
      v-model="selectedItemId"
      :clone-id="cloneId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :read-only="!hasAddAccess"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        disabled-field="cancelled"
        :headers="headers"
      >
        <template
          slot="locations"
          slot-scope="props"
        >
          <v-chip-group column>
            <template v-for="(location, i) of props.item.locations">
              <v-chip
                :key="i"
                :class="{'red lighten-4': location.isBlocker}"
              >
                {{ location.locationName }}
                <!-- <span v-if="location.tableConfigId"><span>&nbsp;</span>({{location.tableConfigName}})</span> -->
              </v-chip>
            </template>
          </v-chip-group>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import EventsItem from './EventsItem'

export default {
  name: 'EventsList',
  components: {EventsItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Event',
      types: 'Events',
      headers: [
        this.headerText('#', 'id'),
        this.headerText('Name', 'name'),
        this.headerSlot('Location', 'locations'),
        this.headerText('Covers', 'coverCount'),
        this.headerText('Reservations', 'activeReservationCount'),
        this.headerText('Date', 'date'),
        this.headerTime('Start', 'startTime'),
        this.headerInvertedSwitch('Active', 'cancelled')
      ],
      apiRecordCommand: 'diningEvent'
    }
  },
  computed: {
    hasAddAccess () {
      return this.$ftAccess.manageEvents
    }
  },
  watch: {
  },
  methods: {
    listCommandFilter (command) {
      this.addCommandParamArrayVal(command, 'include_fields', 'coverCount', 'activeReservationCount', 'locationNames', 'diningEventToLocation.locationName'/*,
      , 'diningEventToLocation.tableConfigName' */)
      return this.addCommandParam(command, 'children', true)
    }
  }
}
</script>
<style>
</style>

